import { render, staticRenderFns } from "./BoxTest.vue?vue&type=template&id=058e0e20"
import script from "./BoxTest.vue?vue&type=script&lang=js"
export * from "./BoxTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports